import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

export default function SmallLoader({
  size = 28,
  color = '#AA66FF',
  label = 'Loading...',
  className,
  centered = true,
  minHeight = 56,
}) {
  return (
    <LoaderWrap className={className} $centered={centered} $minHeight={minHeight}>
      <Spinner $size={size} $color={color} aria-hidden="true" />
      {label ? <Label>{label}</Label> : null}
    </LoaderWrap>
  );
}

const LoaderWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${({ $centered }) => ($centered ? 'center' : 'flex-start')};
  gap: 8px;
  width: 100%;
  min-height: ${({ $minHeight }) => `${$minHeight}px`};
`;

const Spinner = styled.span`
  width: ${({ $size }) => `${$size}px`};
  height: ${({ $size }) => `${$size}px`};
  border-radius: 999px;
  border: 3px solid ${({ $color }) => `${$color}33`};
  border-top-color: ${({ $color }) => $color};
  animation: ${spin} 0.7s linear infinite;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Label = styled.span`
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 14px;
  color: #6b6270;
`;
